<template>
  <div>
    <v-btn
      color="primary"
      small
      @click="generateRFID"
    >
      <div class="d-flex gap5">
        <v-icon>mdi-qrcode-edit</v-icon>
        <span class="">Generate QR Code</span>
      </div>
    </v-btn>

    <Modal
      :is-visible="showModal"
      is-view
      :title="title"
      :sub-title="subTitle"
      :width="width"
      :toggle="closeForm"
    >
      <div
        v-if="rfidData"
        class="d-flex flex-column align-center"
      >
        <qrcode-vue
          ref="qrCode"
          :value="rfidData"
          :size="250"
          level="H"
          render-as="canvas"
        />

        <v-btn
          color="success"
          class="mt-5"
          @click="downloadQRCode"
        >
          <v-icon left>
            mdi-download
          </v-icon>
          Download QR Code
        </v-btn>
      </div>
    </Modal>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "GeneratorQRCode",
  components: {
    QrcodeVue,
    Modal: () => import("@/components/Modals/Modal.vue"),
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default() {
        return "Generate QR Code";
      },
    },
    subTitle: {
      type: String,
      default() {
        return "";
      },
    },

    width: {
      type: String,
      default() {
        return "500px";
      },
    },
    toggle: {
      type: Function,
      default() {
        return void 0;
      },
    },
  },
  data() {
    return {
      showModal: false,
      rfidData: null,
    };
  },
  mounted() {},
  methods: {
    generateRFID() {
      this.showModal = true;

      // Convert complete object into QR Code
      this.rfidData = JSON.stringify(this.item);
    },
    downloadQRCode() {
      const canvas = this.$refs.qrCode.$el.querySelector("canvas");

      if (!canvas) return;

      const link = document.createElement("a");
      link.download = `QR-${this.item.id || "Code"}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    },

    closeForm() {
      this.showModal = false;
      this.toggle();
    },
  },
};
</script>
